import React from "react";
import { withTranslation } from "react-i18next";

import {
  Col,
  Container,
  Row,
  ButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faFilter, faPlus } from "@fortawesome/free-solid-svg-icons";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import StorageService from "../../../../services/StorageService";
import { textFilter } from "react-bootstrap-table2-filter";
import DeviceStatusCell from "./deviceStatusCell/DeviceStatusCell";
import DeviceActionCell from "./deviceActionCell/DeviceActionCell";
import CreateReplacementDevice from "./dialogs/createReplacementDevice/CreateReplacementDevice";
import UnsavedChangesDialog from "../../../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import Button from "react-bootstrap/Button";

class ReplacementDevicesTab extends React.Component {
  constructor(props) {
    super(props);
    this.tableId = "replacementDevicesTable";

    let showFilters = StorageService.getTableConfigValue(
      this.tableId,
      "showFilters"
    );
    this.state = {
      replacementDevices: [],
      showCreateModal: false,
      showUnsavedChangesDialog: false,
      showFilters,
      displayFilter: showFilters ? "initial" : "none",
      dialogApiError: "",
      apiError: "",
    };

    this.loadData = this.loadData.bind(this);
    this.loadCachedData = this.loadCachedData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleCreateReplacementDevice = this.handleCreateReplacementDevice.bind(
      this
    );
    this.handleRAReset = this.handleRAReset.bind(this);
  }

  async componentDidMount() {
    this.paginationTableRef = React.createRef();
    this.loadCachedData();
    await this.loadData();
  }

  async handleRAReset(device) {
    try {
      await CamplaCoreService.resetReplacementDevice(device.id);
      const replacementDevices = await CamplaCoreService.getAllReplacementDevices();
      this.setState({ replacementDevices });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  loadCachedData() {
    const cachedReplacementDevices = StorageService.getReferenceType(
      "replacementDevices"
    );
    if (cachedReplacementDevices)
      this.setState({ replacementDevices: cachedReplacementDevices });
  }

  async loadData() {
    try {
      const replacementDevices = await CamplaCoreService.getAllReplacementDevices();
      this.setState({ replacementDevices });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleCreateReplacementDevice(device) {
    try {
      const createdReplacementDevices = await CamplaCoreService.createReplacementDevice(
        device
      );
      this.setState({
        replacementDevices: [
          createdReplacementDevices,
          ...this.state.replacementDevices,
        ],
        showCreateModal: false,
      });
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleRemove(device) {
    try {
      await CamplaCoreService.removeMemberDevice(device.id);
      const replacementDevices = this.state.replacementDevices.filter(
        (d) => d.id !== device.id
      );
      this.setState({ replacementDevices: [...replacementDevices] });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  render() {
    const { t } = this.props;

    const columns = [
      {
        dataField: "authenticatorId",
        text: "",
        isDummyField: true,
        csvExport: false,
        formatter: (authenticatorId) => {
          return (
            <>
              {authenticatorId === null ? (
                <FontAwesomeIcon icon={faCircle} className="color-green" />
              ) : (
                <FontAwesomeIcon icon={faCircle} className="color-red" />
              )}
            </>
          );
        },
      },
      {
        dataField: "identifier",
        text: t("Hardware.Tabs.ReplacementDevices.ColumnIdentifier"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
        formatter: (identifier) => <span>{identifier}</span>,
      },
      {
        dataField: "name",
        text: t("Hardware.Tabs.ReplacementDevices.ColumnName"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
        formatter: (name) => <span>{name}</span>,
      },
      {
        dataField: "serial",
        text: t("Hardware.Tabs.ReplacementDevices.ColumnSerial"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
        }),
        formatter: (serial) => <span>{serial}</span>,
      },
      {
        dataField: "status",
        text: t("Hardware.Tabs.ReplacementDevices.ColumnStatus"),
        isDummyField: true,
        csvExport: false,
        formatter: (cell, device) => {
          return <DeviceStatusCell device={device} />;
        },
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <ButtonGroup toggle style={{ float: "right", marginRight: "-12px" }}>
            <ToggleButton
              type="checkbox"
              value={1}
              className="btn-green btn-sm"
              checked={this.state.showFilters}
              onChange={(e) => {
                this.setState({
                  showFilters: e.currentTarget.checked,
                  displayFilter: e.currentTarget.checked ? "initial" : "none",
                });
                StorageService.setTableConfigValue(
                  this.tableId,
                  "showFilters",
                  e.currentTarget.checked
                );
              }}
            >
              <FontAwesomeIcon icon={faFilter} />
            </ToggleButton>
          </ButtonGroup>
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: (cell, device) => {
          return (
            <DeviceActionCell
              onReset={() => this.handleRAReset(device)}
              onDelete={() => this.handleRemove(device)}
            />
          );
        },
      },
    ];
    return (
      <div>
        <CreateReplacementDevice
          show={this.state.showCreateModal}
          onHide={(isFormDirty) => {
            if (isFormDirty) {
              this.setState({
                dialogApiError: null,
                showUnsavedChangesDialog: true,
                closeAction: () =>
                  this.setState({
                    showCreateModal: false,
                  }),
              });
            } else {
              this.setState({
                dialogApiError: null,
                showCreateModal: false,
              });
            }
          }}
          onSubmit={this.handleCreateReplacementDevice}
          dialogApiError={this.state.dialogApiError}
        />
        <UnsavedChangesDialog
          show={this.state.showUnsavedChangesDialog}
          onHide={() => this.setState({ showUnsavedChangesDialog: false })}
          onSubmit={() => {
            this.setState({ showUnsavedChangesDialog: false });
            this.state.closeAction();
          }}
        />
        <Container className="mt-3 pl-0 pr-0">
          <Row className="pageTitle">
            <Col>
              <h2>{t("Hardware.Tabs.ReplacementDevices.Title")}</h2>
            </Col>
            <Col>
              <Button
                className="btn-green floatRight"
                onClick={() => this.setState({ showCreateModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row>
            <Col>
              <PaginationTable
                data={this.state.replacementDevices}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField={"id"}
                ref={this.paginationTableRef}
                id={this.tableId}
                view="replacementDevicesTab"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(ReplacementDevicesTab);
